<ng-container [formGroup]="formGroup">
    <mat-checkbox formControlName="null" [indeterminate]="indeterminate">{{property.name}} es nulo.</mat-checkbox>
</ng-container>
